//@flow
import React from "react";
import { Image, Dimensions } from "react-native";
import * as Animatable from "react-native-animatable";
import { Box, MainTitle, Slider } from "app/components/common";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import normalize from "app/utils/normalize";

const { height } = Dimensions.get("window");

const RatingSlide = ({
  title,
  image,
  value,
  onValueChange,
  leftLabel,
  rightLabel,
  scale,
}) => {
  return (
    <Box flex={1} width="100%">
      {!isWebDesktop && (
        <MainTitle variant="l6-bold" textAlign="center">
          {title}
        </MainTitle>
      )}
      <Box flex={1} alignItems="center" justifyContent="center">
        <Animatable.View
          useNativeDriver
          animation={"fadeInLeft"}
          style={styles.middleViewStyle}
        >
          <Image source={image} style={styles.image} resizeMode="contain" />
        </Animatable.View>
      </Box>
      {isWebDesktop && (
        <MainTitle variant="l6-bold" textAlign="center" marginBottom="xxl">
          {title}
        </MainTitle>
      )}
      <Slider
        value={value}
        onValueChange={onValueChange}
        leftLabel={leftLabel}
        rightLabel={rightLabel}
      />
    </Box>
  );
};

const styles = {
  middleViewStyle: {
    marginBottom: 50,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  image: {
    height: isWebDesktop ? normalize(174) : (height * 1) / 3,
    width: normalize(209),
  },
};

export default RatingSlide;
